import { render, staticRenderFns } from "./UIDatePicker.vue?vue&type=template&id=b86cdab2"
import script from "./UIDatePicker.vue?vue&type=script&lang=ts"
export * from "./UIDatePicker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports